import { useEffect } from 'react';
import { getDesignUpScale } from '../utils/designScale';

/** `--st-up`: 기준 해상도(1920×1080)보다 큰 화면에서의 확대 배율 — CSS에서 크기 상한에 곱해 쓴다 */
export function useDesignScaleVar() {
  useEffect(() => {
    const root = document.documentElement;
    const apply = () => root.style.setProperty('--st-up', String(getDesignUpScale()));
    apply();
    window.addEventListener('resize', apply);
    return () => window.removeEventListener('resize', apply);
  }, []);
}
